module.exports = __webpack_public_path__ + "img/bg-ovals.ae193030.svg";